import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FONT_SANS } from '../constants';
import { colors } from '../theme/colors';

export const PolicyPage = styled.main`
  max-width: 760px;
  margin: 0 auto;
  padding: 56px clamp(20px, 5vw, 32px) 96px;

  h1 {
    font-size: clamp(28px, 5vw, 42px);
    line-height: 1.15;
    margin: 0 0 16px;
    letter-spacing: -0.02em;
  }

  h2 {
    font-size: clamp(20px, 3vw, 26px);
    line-height: 1.25;
    margin: 40px 0 12px;
  }

  h3 {
    font-size: 17px;
    margin: 24px 0 8px;
  }

  p, li {
    color: #4a4a52;
    line-height: 1.65;
  }

  ul {
    padding-left: 22px;
  }

  li {
    margin: 6px 0;
  }

  .lede {
    font-size: 18px;
  }

  .muted {
    color: #71717a;
    font-size: 14px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    font-size: 14px;
  }

  th, td {
    border: 1px solid #ececef;
    padding: 10px 12px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #fafafa;
    font-weight: 700;
    color: #0a0a0a;
  }

  a {
    color: ${colors.accent};
  }
`;

export const SiteHeaderBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  background: color-mix(in srgb, #ffffff 88%, transparent);
  backdrop-filter: saturate(150%) blur(12px);
  border-bottom: 1px solid #ececef;
`;

export const SiteHeaderInner = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 14px clamp(20px, 5vw, 32px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const BrandLink = styled(Link)`
  font-family: ${FONT_SANS};
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${colors.ink};
  text-decoration: none;

  &:hover {
    color: ${colors.accent};
  }
`;

export const SiteNav = styled.nav`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;

  a {
    color: #4a4a52;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      color: #0a0a0a;
    }
  }
`;

export const SiteFooterBar = styled.footer`
  border-top: 1px solid #ececef;
  padding: 32px clamp(20px, 5vw, 32px);
  text-align: center;
  color: #71717a;
  font-size: 13px;

  nav {
    display: flex;
    gap: 18px;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }

  nav a {
    color: #71717a;
    text-decoration: none;

    &:hover {
      color: #2563eb;
    }
  }
`;
